import { css } from '@emotion/react';
import { DayOfWeek } from '@weave/schema-gen-ts/dist/shared/schedule/schedule.pb';
import { useTranslation } from '@frontend/i18n';
import { StatusBadge } from '../../../../../../../../components/status-badge';

export const PreferredDays = ({ preferredDays }: { preferredDays: DayOfWeek[] }) => {
  const { t } = useTranslation('schedule-request');
  const days: { value: DayOfWeek; label: string }[] = [
    { value: DayOfWeek.MONDAY, label: t('Mon') },
    { value: DayOfWeek.TUESDAY, label: t('Tue') },
    { value: DayOfWeek.WEDNESDAY, label: t('Wed') },
    { value: DayOfWeek.THURSDAY, label: t('Thu') },
    { value: DayOfWeek.FRIDAY, label: t('Fri') },
    { value: DayOfWeek.SATURDAY, label: t('Sat') },
    { value: DayOfWeek.SUNDAY, label: t('Sun') },
  ];
  const hasNoPreferredDays = !preferredDays.length;

  return (
    <div css={containerStyles}>
      {days.map(({ value, label }) => (
        <StatusBadge key={value} variant={hasNoPreferredDays || preferredDays.includes(value) ? 'green' : undefined}>
          {label}
        </StatusBadge>
      ))}
    </div>
  );
};

const containerStyles = css`
  display: flex;
  gap: var(--fabric-space-gap-xs);
`;
